import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { ProductSection } from '../components/ProductSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ResultsSection } from '../components/ResultsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="bg-gamer-dark min-h-screen text-white selection:bg-gamer-red selection:text-white" data-id="element-225">
      <HeroSection data-id="element-226" />
      <ProblemSection data-id="element-227" />
      <IdentificationSection data-id="element-228" />
      <BenefitsSection data-id="element-229" />
      <ResultsSection data-id="element-230" />
      <TestimonialsSection data-id="element-231" />
      <ProductSection data-id="element-232" />
      <CTASection data-id="element-233" />
      <Footer data-id="element-234" />
    </main>;
}